import { Observable } from 'rxjs';
import { QueryBuilderQuery } from '@ardoq/api-types';
import { reducer, reducedStream } from '@ardoq/rxbeach';
import { setComponentSelectQuery } from '../../actions';

export type QuerySelectComponent = {
  query: QueryBuilderQuery | null;
};

const reduceSetSelectComponentQuery = (
  state: QuerySelectComponent,
  { query }: { query: QueryBuilderQuery | null }
): QuerySelectComponent => ({ ...state, query });

// TODO make it non persistent
export const getQuerySelectComponent$ = (
  namespace: string
): Observable<QuerySelectComponent> =>
  reducedStream(
    'querySelectComponent$',
    {
      query: null,
    },
    [reducer(setComponentSelectQuery, reduceSetSelectComponentQuery)],
    { namespace }
  );
